import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {SiteFiltersType} from "../../types/site-filters.type";
import {ViewFilterSettingsService} from "../../services/view-filter-settings.service";
import {CommonsDialogService} from "../../services/commons-dialog.service";
import {FulfillmentSubTypeType} from "../../../fulfillment/types/fulfillment-sub-type.type";
import {AddressQualityEnum} from "../../../addresses/types/address-quality.enum";

export class BringozFiltersButtonComponent implements IController {

  includeFilters: SiteFiltersType[];
  optionIdsMap: any;
  excludeIdsMap: any;
  filters: any;
  selectedQuickFilterId?: string;
  pageName?: string;
  queryMap: {};
  hideDisplay?: boolean;
  hideText?: boolean;
  isDisabled?: boolean;
  disabledText?: string;
  onChange: Function;

  private subFiltersTypes: SiteFiltersType[];
  private fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;

  /* @ngInject */
  constructor(private commonsDialogService: CommonsDialogService, private $log: ILogService, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.subFiltersTypes = [
      SiteFiltersType.noArea,
      SiteFiltersType.serviceAreaPickup,
      SiteFiltersType.serviceAreaDropoff,
      SiteFiltersType.serviceAreasServiceTypes,
      SiteFiltersType.noPickUpArea,
      SiteFiltersType.noDropOffArea,
      SiteFiltersType.groups
    ]
  }

  $onInit() {
  };

  $onChanges(changes) {
  };

  openDialog($event) {
    this.commonsDialogService.siteFilters($event, this.includeFilters, angular.copy(this.filters), this.selectedQuickFilterId, this.pageName, this.queryMap, this.excludeIdsMap, this.optionIdsMap)
      .then((res) => {
        this._setContextIds(res?.filters);
        this.onChange({filters: res?.filters, selectedQuickFilter: res?.selectedQuickFilter});
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  hasFilters() {
    return !!this.includeFilters.find((f) => {
      if (this.subFiltersTypes.includes(f)) {
        return false;
      }
      return _.isArray(this.filters[f]) ? !!this.filters[f]?.length : !_.isUndefined(this.filters[f]);
    });
  }

  onResetFilter(filterName) {
    if (filterName === 'groupIds') {
      this.excludeIdsMap.branchIds = [];
    }

    if ((filterName === 'accountPickup' && !this.filters.accountDropoff) || (filterName === 'accountDropoff' && !this.filters.accountPickup)) {
      this.filters.taskAccountIds = [];
    }

    this.filters[filterName] = _.isArray(this.filters[filterName]) ? [] : undefined;

    if (filterName === 'serviceAreaIds' && !_.isUndefined(this.filters.noArea) && !_.isUndefined(this.filters.noPickUpArea) && !_.isUndefined(this.filters.noDropOffArea)) {
      this.filters.noArea = false;
      this.filters.noDropOffArea = false;
      this.filters.noPickUpArea = false;
    }

    this._setContextIds(this.filters);

    this.onChange({filters: this.filters});
  }

  private _setContextIds(filters) {
    this.viewFilterSettingsService.setServiceAreaIds(filters?.serviceAreaIds || []);
    this.viewFilterSettingsService.setBranchIds(filters?.branchIds || []);
    this.viewFilterSettingsService.setAccountIds(filters?.accountIds || []);
    this.viewFilterSettingsService.setBillingAccountIds(filters?.billingAccountIds || []);
    this.viewFilterSettingsService.setBillingOrderStatus(filters?.billingOrderStatus || undefined);
    this.viewFilterSettingsService.setTags(filters?.tags || []);
    this.viewFilterSettingsService.setPackagesIds(filters?.packagesIds || []);
    this.viewFilterSettingsService.setBillingOrderInvoiceStatuses(filters?.billingOrderInvoiceStatuses || []);
    this.viewFilterSettingsService.setIsConsolidated(typeof filters?.isConsolidated === "boolean" ? filters?.isConsolidated : undefined);
    this.viewFilterSettingsService.setHasPrice(typeof filters?.hasPrice === "boolean" ? filters?.hasPrice : undefined);
    this.viewFilterSettingsService.setDateRangeTemplateType(filters.dateRangeTemplateType || undefined);

  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozFiltersButton', {
    bindings: {
      includeFilters: '<',
      excludeIdsMap: '<',
      optionIdsMap: '<',
      filters: '<',
      selectedQuickFilterId: '<?',
      pageName: '<?',
      queryMap: '<?',
      hideDisplay: '<?',
      hideText: '<?',
      isDisabled: '<?',
      disabledText: '@?',
      onChange: '&'
    },
    template: require('./bringoz-filters-button.html').default,
    controller: BringozFiltersButtonComponent
  });
